import { Route, Routes } from "react-router-dom";
import Account from "./Account";
import DeviceOrders from "./DeviceOrders";
import Downloads from "./Downloads";
import Faq from "./Faq";
import Home from "./Home";
import Purchase from "./Purchase";
import Settings from "./Settings";
import Success from "./Success";
import Stubtracker from "./Stubtracker";

export const router = [
  { path: "/", element: <Home></Home> },
  { path: "/account", element: <Account></Account> },
  { path: "/settings", element: <Settings></Settings> },
  { path: "/downloads", element: <Downloads></Downloads> },
  { path: "/faq", element: <Faq></Faq> },
  { path: "/purchase", element: <Purchase></Purchase> },
  { path: "/device-orders", element: <DeviceOrders></DeviceOrders> },
  { path: "/success", element: <Success></Success> },
  { path: "/stubtracker", element: <Stubtracker></Stubtracker> },
];

const Router = () => (
  <Routes>
    {router.map((route, idx) => (
      <Route key={idx} path={route.path} element={route.element}></Route>
    ))}
  </Routes>
);

export default Router;
